'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase().replace(/\b[:-]\b/g, '')
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-to-hyperscript/~/property-information/normalize.js
// module id = 202
// module chunks = 251080691916612